angular.module('impactx.passwordrecovery').controller('CustomPasswordRecoveryDialogCtrl', [
    '$scope',
    'AppConfiguration',
    'passwordRecoveryData',
    'dataGen',
    'ToastService',
    '$redirect',
    'themeFactory',
    'LoginService',
    'customHash',
    'customLogoURL',
    '$config',
    CustomPasswordRecoveryDialogCtrl]);

function CustomPasswordRecoveryDialogCtrl($scope, AppConfiguration, passwordRecoveryData, dataGen, ToastService, $redirect,
                                    themeFactory, LoginService, customHash, customLogoURL, $config) {
    $scope.logoUrl = customLogoURL;
    $scope.data = passwordRecoveryData;
    $scope.theme = themeFactory.getTheme();
    $scope.hasError = !!$scope.data.validationError;
    $scope.customHash = customHash;
    $scope.loginRoute =  $config.customLoginRoute + "/" + customHash;
    $scope.changePassword = function () {
        if (!$scope.hasError) {
            dataGen.postAsForm($scope, {passwordRecovery: $scope.data}, "/passwordrecovery/changepassword").then(function (data) {
                if (!data.error) {
                    $scope.dialogData.passwordRepeat.$setValidity("passwordChange", true);
                    ToastService.openStandardToast(data.successMessage);
                    $redirect.redirectTo(null, $scope.loginRoute);
                }
                else {
                    $scope.passwordChangeError = data.error;
                    $scope.dialogData.passwordRepeat.$setValidity("passwordChange", false);
                }
            });
        }
    }
}